module.exports = __webpack_public_path__ + "img/parameter.9a748917.png";